import { apiFetch } from './apiClient';

export const fetchDashboardChartData = async (product_id, meta_key, group_by_period, start_date, end_date, compare_start_date, compare_end_date) => {
    try {
        const params = new URLSearchParams({
            group_by_period,
            start_date,
            end_date,
        });

        if (compare_start_date && compare_end_date) {
            params.set('compare_start_date', compare_start_date);
            params.set('compare_end_date', compare_end_date);
        }

        const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/dashboard/${product_id}/${meta_key}?${params.toString()}`;

        const response = await apiFetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        const responseData = await response.json();
        return responseData.data;
    } catch (error) {
        throw error;
    }
};

export const fetchDashboardStats = async (product_id) => {
    try {
        const response = await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/api/v1/dashboard/${product_id}/stats`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        const responseData = await response.json();
        return responseData.data;
    } catch (error) {
        throw error;
    }
};

export const addNewStore = async (storeData) => {
    try {
        const response = await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/api/v1/stores/add-store`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
            },
            body: storeData,
        });

        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }

        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error('Error adding new store:', error);
        throw error;
    }
};

export const fetchStores = async (storeId) => {
    let url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/stores`;

    if (storeId) {
        url += `/${storeId}`;
    }
    try {
        const response = await apiFetch(url, {

            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.statusText}`);
        }

        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error('Error fetching stores:', error);
        throw error;
    }
};

export const updateStoreData = async (storeId, storeData) => {
    try {
        const response = await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/api/v1/stores/${storeId}/settings`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(storeData)
        });

        if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.statusText}`);
        }

        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error('Error updating store data:', error);
        throw error;
    }
};

export const addNewProduct = async (productData) => {
    try {
        const response = await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/api/v1/product`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify(productData),
        });

        if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error adding new product:', error);
        throw error;
    }
};

export const fetchStoreUsers = async (storeId, page = 1, perPage = 10, searchTerm = '') => {
    try {
        let url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/stores/${storeId}/users?page=${page}&per_page=${perPage}`;

        // Add the search term if it is provided
        if (searchTerm) {
            url += `&search=${encodeURIComponent(searchTerm)}`;
        }

        const response = await apiFetch(url, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
            }
        });

        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }

        return await response.json();
    } catch (error) {
        throw error;
    }
};


export const fetchUsers = async (productId, page = 1, perPage = 10, searchTerm = '') => {
    try {
        let url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/${productId}/customers?page=${page}&per_page=${perPage}`;

        // Add the search term if it is provided
        if (searchTerm) {
            url += `&search=${encodeURIComponent(searchTerm)}`;
        }

        const response = await apiFetch(url, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
            }
        });

        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }

        return await response.json();
    } catch (error) {
        throw error;
    }
};

export const updateEmailAddresses = async (productId, emailData) => {
    try {
        const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/${productId}/email-addresses`;

        const response = await apiFetch(url, {
            method: 'POST',  // Assuming you are using POST to update email addresses
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',  // Ensure we are sending JSON
            },
            body: JSON.stringify(emailData),  // Sending the email data as JSON in the request body
        });

        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }

        return await response.json();
    } catch (error) {
        throw error;
    }
};

export const updateVerification = async (userId, value) => {
    try {
        const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/${userId}/verification-toggle`;

        const response = await apiFetch(url, {
            method: 'POST',  // Assuming you are using POST to update email addresses
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',  // Ensure we are sending JSON
            },
            body: JSON.stringify(value),  // Sending the email data as JSON in the request body
        });

        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }

        return await response.json();
    } catch (error) {
        throw error;
    }
};

export const fetchEmailAddresses = async (productId) => {
    try {
        const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/email-addresses/${productId}`;

        const response = await apiFetch(url, {
            method: 'GET',  // Use GET method to retrieve data
            headers: {
                'accept': 'application/json',  // Expecting JSON response
            },
        });

        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }

        return await response.json();  // Parse and return the response as JSON
    } catch (error) {
        throw error;  // Handle errors
    }
};

export const fetchEmailLogs = async (userId, page = 1, perPage = 10) => {
    try {
        const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/users/${userId}/email-logs?page=${page}&per_page=${perPage}`;

        const response = await apiFetch(url, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }

        return await response.json();
    } catch (error) {
        throw error;
    }
};

export const UserData = async (user_id) => {
    try {
        const response = await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/api/user/details/${user_id}`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        return await response.json();
    } catch (error) {
        throw error;
    }
};

export const updateUserData = async (userData, userId) => {
    try {
        const response = await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/api/user/profile/${userId}`, {
            method: 'PUT',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(userData),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(`Network response was not ok: ${errorData.message}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error updating user data:', error);
        throw error;
    }
};

export const fetchUser = async (user_id) => {
    try {
        const response = await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/api/v1/customers/${user_id}`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
            }
        });
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        return await response.json();
    } catch (error) {
        throw error;
    }
};

export const fetchSites = async (productId, page, perPage, userId = null, searchTerm = '', stateFilter = '', reason = null, onlyProduction = false) => {
    try {
        // Base URL for the API call
        let url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/${productId}/sites?page=${page}&per_page=${perPage}`;

        // Add userId parameter if provided
        if (userId) {
            url += `&customerId=${userId}`;
        }

        // Add searchTerm parameter if provided
        if (searchTerm) {
            url += `&search=${encodeURIComponent(searchTerm)}`;
        }

        // Add stateFilter parameter if provided
        if (stateFilter) {
            url += `&state_filter=${encodeURIComponent(stateFilter)}`;
        }

        // Add reason parameter if provided
        if (reason) {
            url += `&reason=${encodeURIComponent(reason)}`;
        }

        // Add onlyProduction parameter to filter production sites (https, .com, etc.)
        if (onlyProduction) {
            url += `&only_production=1`;
        }

        // Make the API call
        const response = await apiFetch(url, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });

        // Check for a successful response
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }

        // Return the JSON response
        return await response.json();
    } catch (error) {
        console.error('Fetch error:', error); // Log error details
        throw error; // Rethrow the error for further handling if needed
    }
};

export const fetchUninstallReasons = async (productId) => {
    try {
        let url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/dashboard/${productId}/uninstall-reasons`;

        const response = await apiFetch(url, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });

        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }

        return await response.json();
    } catch (error) {
        console.error('Fetch error:', error); // Log error details
        throw error;
    }
};


export const fetchStoreSites = async (storeId, page = 1, perPage = 10, searchTerm = '', userId = null) => {
    try {
        let url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/stores/${storeId}/sites?page=${page}&per_page=${perPage}`;


        if (userId) {
            url += `&customerId=${userId}`;
        }

        if (searchTerm) {
            url += `&search=${encodeURIComponent(searchTerm)}`;
        }

        const response = await apiFetch(url, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });

        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }

        return await response.json();
    } catch (error) {
        console.error('Fetch error:', error); // Log error details
        throw error;
    }
};

export const fetchStoreEventLogs = async (storeId, page, type, userId = null, siteId = null) => {
    try {


        let url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/stores/${storeId}`;


        url += `/events-log?page=${page}`;

        if (userId) {
            url += `&customerId=${userId}`;
        }

        if (siteId) {
            url += `&siteId=${siteId}`;
        }

        const response = await apiFetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({type})
        });
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }

        return await response.json();
    } catch (error) {
        throw error;
    }
};


export const fetchEventLogs = async (productId, page, perPage, type, userId = null, siteId = null) => {
    try {


        let url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/products/${productId}`;


        url += `/product-events-log?page=${page}&per_page=${perPage}`;

        if (userId) {
            url += `&customerId=${userId}`;
        }

        if (siteId) {
            url += `&siteId=${siteId}`;
        }

        const response = await apiFetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({type})
        });
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }

        return await response.json();
    } catch (error) {
        throw error;
    }
};

export const fetchProductSettings = async (productId) => {
    try {
        const response = await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/api/v1/product-settings/${productId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        return await response.json();
    } catch (error) {
        throw error;
    }
}

export const fetchSiteInfo = async (siteId) => {

    if (!siteId) {
        console.error('siteId is not defined!');
        return;
    }
    try {
        const response = await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/api/v1/sitemeta/${siteId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            }
        });

        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching site info:', error); // Improved error logging
        throw error;
    }
}


export const fetchThemesPlugins = async (siteId, page = 1, PerPage = 10) => {
    try {
        if (!siteId) {
            throw new Error('SiteID is not defined!');
        }

        const response = await apiFetch(
            `${process.env.REACT_APP_API_BASE_URL}/api/v1/siteplugins/${siteId}?page=${page}&per_page=${PerPage}`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );

        if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.status} - ${response.statusText}`);
        }

        const data = await response.json();
        if (!data || typeof data.data === 'undefined' || typeof data.total === 'undefined') {
            throw new Error('API response structure is invalid. Expected keys: "data", "total".');
        }

        return data;
    } catch (error) {
        console.error('Error fetching themes and plugins:', error);
        throw error; 
    }
};


export const fetchSiteEventLogs = async (siteID) => {
    try {
        if (!siteID) {
            throw new Error('SiteID is not defined!');
        }


        // Append siteID as a query parameter in the URL
        const response = await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/api/v1/site-events/${siteID}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            // Throwing a detailed error including status code and status text
            throw new Error(`Network response was not ok: ${response.status} - ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching themes and plugins:', error);
        throw error; // Re-throw the error to be handled by the calling function
    }
};

export const ScriptInfo = async (productId) => {
    try {
        const response = await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/api/v1/integration-script/${productId}`, {
            method: 'GET',
            headers: {
                'Accept': 'text/plain',
                'Content-Type': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        return await response.text();
    } catch (error) {
        throw error;
    }
}

export const saveProductSettings = async (productData, productId) => {
    try {
        const response = await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/api/v1/update-product-settings/${productId}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                slug: productData.slug,
                title: productData.title,
                website: productData.website,
                short_description: productData.short_description
            })
        });
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        return await response.json();
    } catch (error) {
        throw error;
    }
}


export const getUserProducts = async (productData) => {
    try {
        const response = await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/api/v1/user-products`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        return await response.json();
    } catch (error) {
        throw error;
    }
}


export const getUserStoresWithProducts = async (productData) => {
    try {
        const response = await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/api/v1/stores`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        return await response.json();
    } catch (error) {
        throw error;
    }
}

export const fetchUserNotes = async (userId) => {
    try {
        const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/user/${userId}/notes`;
        const response = await apiFetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching user notes:', error);
        throw error;
    }
};

export const addUserNote = async (userId, noteContent) => {
    try {
        const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/user/${userId}/notes`;
        const response = await apiFetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ note: noteContent }),
        });
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        return await response.json();
    } catch (error) {
        console.error('Error adding user note:', error);
        throw error;
    }
};

export const updateUserNote = async (userId, noteContent) => {
    try {
        const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/user/${userId}/notes`;
        const response = await apiFetch(url, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ note: noteContent }),
        });
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        return await response.json();
    } catch (error) {
        console.error('Error updating user note:', error);
        throw error;
    }
};

export const deleteUserNotes = async (userId) => {
    try {
        const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/user/${userId}/notes`;
        const response = await apiFetch(url, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        return await response.json();
    } catch (error) {
        console.error('Error deleting user notes:', error);
        throw error;
    }
};

export const fetchFeatureUsage = async (productId, params) => {
    try {
        const query = params ? `?${params.toString()}` : '';
        const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/dashboard/${productId}/feature-usage${query}`;
        const response = await apiFetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        const responseData = await response.json();
        return responseData.data;
    } catch (error) {
        console.error('Error fetching feature usage:', error);
        throw error;
    }
};
